<template>
    <div class="report-index">
        <transition name="fade-transform" mode="out-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'report-index',
        data() {
            return {}
        },
        mounted() {

        },
        methods: {}
    }
</script>

<style lang="scss">
    .report-index {
        .publicBg {
            background-color: #fff;
            border-radius: 6px;
        }
        .report-table{
            padding-top: 20px;
        }
        .report-filter-container {
            display: flex;
            align-items: center;
            .date-detail-filter{
                display: flex;
                align-items: center;
                .date-item{
                    margin-left: 40px;
                    font-size: 12px;
                    color: #333;
                    cursor: pointer;
                    padding-bottom: 4px;
                    border-bottom: 2px solid #fff;
                    &.date-actived{
                        color: $mainColor;
                        border-bottom: 2px solid $mainColor;
                    }
                }
            }
            .report-filter-top-button{
                margin-left: auto;
            }
        }
        .report-total-analyze {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            flex-wrap: wrap;
            align-content: flex-start;
            padding-top: 15px;

            .report-total-analyze-item {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 15px;
                margin-bottom: 15px;
                width: 19%;

                .analyze-count {
                    font-weight: bold;
                    display: block;
                    font-size: 14px;
                    color: #4ca0ff;
                    padding-top: 8px;


                }

                .total-analyze-item-icon {
                    padding-right: 10px;

                    .svg-icon {
                        width: 60px;
                        height: 60px;
                    }
                }

                .total-analyze-item-desc {
                    color: #333;
                    font-size: 12px;
                    line-height: 20px;
                    text-align: center;

                    .desc-title {
                        font-size: 14px;
                    }
                }
            }
        }
        .small-chart-container {
            margin-top: 15px;
            display: flex;
            justify-content: space-between;

            & > div {
                flex: 1;
                padding: 24px 28px;
                margin-right: 20px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
        .pie-chart-nodata{
            text-align: center;
            line-height: 480px;
        }
        .line-chart-nodata{
            text-align: center;
            line-height: 380px;
        }
    }
</style>
